import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat',
  pure: true
})
export class DateFormatPipe implements PipeTransform {
  transform(value: Date | moment.Moment, format: string): string {
    if (value) {
      return moment(value).format(format);
    }
    return '';
  }
}